const getOrderLineType = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    return indexOrderLine ? indexOrderLine.Type : null;
  }
  return orderLine
    ? orderLine.map(item => item.Type).join(', ')
    : null;
};

export default getOrderLineType;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineType.js